<template>
    <div>
        <DetailsFilters
            :filters.sync="filters"
            :is-loading="isLoading"
            :advertiser="advertiser"
            @clear="clearFilters"
            @update="update">
        </DetailsFilters>
        <DetailsTable
            class="mt-2"
            :data="statistic"
            :is-loading="isLoading"
            :currency="currency_">
        </DetailsTable>
    </div>
</template>

<script>
  import { momentInst } from "@core/filters";
  import { FilteredComponent } from "@core/mixins";
  import { GET_STATISTIC, SET_EMPTY } from "@core/store/action-constants";
  import { mapActions, mapMutations, mapState } from "vuex";
  import DetailsFilters from "./AdvertisersTableDetailsModalDetails/DetailsFilters";
  import DetailsTable from "./AdvertisersTableDetailsModalDetails/DetailsTable";
  
  export default {
    name: "AdvertisersTableDetailsModalDetails",
    mixins: [FilteredComponent],
    components: {
      DetailsTable,
      DetailsFilters
    },
    props: {
      advertiser: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        filters: {
          datepicker: {
            dateStart: momentInst().startOf("day").subtract(7, "day").toDate(),
            dateEnd: momentInst().endOf("day").toDate()
          },
          groups: ["webmaster", "offer"],
          webmasterId: null,
          currency: this.$store.state.auth.preferredCurrency,
          offerId: null
        },
        currency_: this.$store.state.auth.preferredCurrency
      };
    },
    computed: {
      ...mapState("admin/statistic", {
        statistic: ({ statistics }) => statistics
      }),

      isLoading () {
        return this.$wait(`admin/statistic/${ GET_STATISTIC }`);
      }
    },
    methods: {
      ...mapActions("admin/statistic", [
        GET_STATISTIC
      ]),

      ...mapMutations("admin/statistic", [
        SET_EMPTY
      ]),

      update () {
        const { datepicker, groups, ...filters } = this.filters;
        const queryGroups = groups.map(item => item?.toUpperCase()).filter(Boolean);

        this.GET_STATISTIC({
          groups: queryGroups,
          filters: { ...datepicker, ...filters, advertiserId: this.advertiser?.id }
        });
        this.currency_ = filters.currency;
      }
    },
    destroyed () {
      this.SET_EMPTY();
    }
  };
</script>

<style scoped>

</style>
